/**
 * Applied default webkit styling to the children
 * Used for diplaying WYSIWYG text like product abstract and description
 */
 import convertToHtml from 'common/fragments/ConvertToHtml';
interface IHtmlDefaultProps {
	html?: string; // avoid using if possible due to XSS risks
}

const HtmlDefault: React.SFC<IHtmlDefaultProps> = ({children, html}) => (
	<div className="html-default">
		{html ? (
			<div dangerouslySetInnerHTML={{__html: html ? getHtml(html) : "<b>[]</b>"}} />
		) : (
			{children}
		)}
	</div>
);

function getHtml(str:string){
	try {
		if(str!== "null")
			return convertToHtml(str);
		else
			return "<b>[]</b>";
	} catch (e) {
		return str;
	}
}

export default HtmlDefault;



// WEBPACK FOOTER //
// ./src/common/fragments/HtmlDefault.tsx